'use strict';

var _defineProperty2 = require('babel-runtime/core-js/object/define-property');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = _assign2.default || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _countryList = require('country-list');

var _countryList2 = _interopRequireDefault(_countryList);

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { (0, _defineProperty3.default)(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var countries = (0, _countryList2.default)().getData()
// Per SEC regulations, Entoro is unable to accept investments from Iraq or North Korea
.filter(function (_ref) {
  var code = _ref.code;
  return code !== 'IQ' && code !== 'KP';
});

// https://github.com/fannarsh/country-list/blob/master/country-list.js
// Create a map manually, because getCodeList() returns lowercase codes ¯\_(ツ)_/¯
var countryMap = countries.reduce(function (map, _ref2) {
  var code = _ref2.code,
      name = _ref2.name;
  return _extends({}, map, _defineProperty({}, code, name));
}, {});

exports.default = new _Dictionary2.default(countryMap);